import { __assign, __awaiter, __generator, __read, __spreadArray } from "tslib";
var alreadyInstantiated = new WeakMap();
var INTERACTOR_CONFIG_KEY = Symbol("INTERACTOR_CONFIG_KEY");
var InteractorConfig = (function () {
    function InteractorConfig(proto) {
        this.proto = proto;
        this.cleanupMethods = new Map();
        this.errorMethods = new Map();
        this.setupMethods = new Map();
        this.afterMethods = new Map();
    }
    InteractorConfig.prototype.hasErrorMethod = function (_a) {
        var _b = _a.scope, scope = _b === void 0 ? "all" : _b;
        return this.errorMethods.has(scope);
    };
    InteractorConfig.prototype.eachErrorMethod = function (method, _a) {
        var _b;
        var _c = _a.scope, scope = _c === void 0 ? "all" : _c;
        return ((_b = this.errorMethods.get(scope)) !== null && _b !== void 0 ? _b : []).map(method);
    };
    InteractorConfig.prototype.addErrorMethod = function (method, _a) {
        var _b;
        var _c = _a.scope, scope = _c === void 0 ? "all" : _c;
        this.errorMethods.set(scope, __spreadArray(__spreadArray([], __read(((_b = this.errorMethods.get(scope)) !== null && _b !== void 0 ? _b : [])), false), [
            method
        ], false));
    };
    InteractorConfig.prototype.eachSetupMethod = function (method, _a) {
        var _b;
        var _c = _a.scope, scope = _c === void 0 ? "all" : _c;
        return ((_b = this.setupMethods.get(scope)) !== null && _b !== void 0 ? _b : []).map(method);
    };
    InteractorConfig.prototype.addSetupMethod = function (method, _a) {
        var _b;
        var _c = _a.scope, scope = _c === void 0 ? "all" : _c;
        this.setupMethods.set(scope, __spreadArray(__spreadArray([], __read(((_b = this.setupMethods.get(scope)) !== null && _b !== void 0 ? _b : [])), false), [
            method
        ], false));
    };
    InteractorConfig.prototype.eachAfterMethod = function (method, _a) {
        var _b;
        var _c = _a.scope, scope = _c === void 0 ? "all" : _c;
        return ((_b = this.afterMethods.get(scope)) !== null && _b !== void 0 ? _b : []).map(method);
    };
    InteractorConfig.prototype.addAfterMethod = function (method, _a) {
        var _b;
        var _c = _a.scope, scope = _c === void 0 ? "all" : _c;
        this.afterMethods.set(scope, __spreadArray(__spreadArray([], __read(((_b = this.afterMethods.get(scope)) !== null && _b !== void 0 ? _b : [])), false), [
            method
        ], false));
    };
    InteractorConfig.prototype.eachCleanupMethod = function (method, _a) {
        var _b;
        var _c = _a.scope, scope = _c === void 0 ? "all" : _c;
        return ((_b = this.cleanupMethods.get(scope)) !== null && _b !== void 0 ? _b : []).map(method);
    };
    InteractorConfig.prototype.addCleanupMethod = function (method, _a) {
        var _b;
        var _c = _a.scope, scope = _c === void 0 ? "all" : _c;
        this.cleanupMethods.set(scope, __spreadArray(__spreadArray([], __read(((_b = this.cleanupMethods.get(scope)) !== null && _b !== void 0 ? _b : [])), false), [
            method
        ], false));
    };
    InteractorConfig.prototype.clone = function (proto) {
        var clone = new InteractorConfig(proto);
        clone.cleanupMethods = new Map(this.cleanupMethods);
        return clone;
    };
    InteractorConfig.forInstance = function (entity) {
        return this.forPrototype(Object.getPrototypeOf(entity));
    };
    InteractorConfig.forConstructor = function (constructor) {
        return this.forPrototype(constructor.prototype);
    };
    InteractorConfig.forPrototype = function (proto) {
        var _a;
        var p = proto;
        var config = (_a = p[INTERACTOR_CONFIG_KEY]) !== null && _a !== void 0 ? _a : new InteractorConfig(p);
        if (config.proto !== p) {
            config = config.clone(p);
        }
        p[INTERACTOR_CONFIG_KEY] = config;
        return config;
    };
    return InteractorConfig;
}());
function MakeDecorator(decorator) {
    return function (target, propertyKey, passedDescriptor) {
        var descriptor = passedDescriptor !== null && passedDescriptor !== void 0 ? passedDescriptor : Object.getOwnPropertyDescriptor(target, propertyKey);
        decorator({
            interactorConfig: InteractorConfig.forPrototype(target),
            target: target,
            method: descriptor.value,
            descriptor: passedDescriptor,
            replaceMethod: function (replacement) {
                descriptor.value = replacement;
            }
        });
    };
}
export function Method(config) {
    if (config === void 0) { config = {}; }
    return MakeDecorator(function (_a) {
        var method = _a.method, interactorConfig = _a.interactorConfig, replaceMethod = _a.replaceMethod;
        replaceMethod(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var isolated_1, response, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!alreadyInstantiated.has(this)) return [3, 11];
                            isolated_1 = Object.create(this.constructor.prototype);
                            Object.assign(isolated_1, __assign({}, this));
                            alreadyInstantiated.set(isolated_1, true);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 5, 8, 10]);
                            return [4, Promise.all(interactorConfig.eachSetupMethod(function (m) { return m.call(isolated_1); }, config))];
                        case 2:
                            _a.sent();
                            return [4, method.call.apply(method, __spreadArray([isolated_1], __read(args), false))];
                        case 3:
                            response = _a.sent();
                            return [4, Promise.all(interactorConfig.eachAfterMethod(function (m) { return m.call(isolated_1); }, config))];
                        case 4:
                            _a.sent();
                            return [2, response];
                        case 5:
                            e_1 = _a.sent();
                            if (!interactorConfig.hasErrorMethod(config)) return [3, 7];
                            return [4, Promise.race(interactorConfig.eachErrorMethod(function (m) { return m.call(isolated_1, e_1); }, config))];
                        case 6: return [2, _a.sent()];
                        case 7: throw e_1;
                        case 8: return [4, Promise.all(interactorConfig.eachCleanupMethod(function (m) { return m.call(isolated_1); }, config))];
                        case 9:
                            _a.sent();
                            return [7];
                        case 10: return [3, 12];
                        case 11: return [2, method.bind(this).apply(void 0, __spreadArray([], __read(args), false))];
                        case 12: return [2];
                    }
                });
            });
        });
    });
}
export function Finally(config) {
    if (config === void 0) { config = {}; }
    return MakeDecorator(function (_a) {
        var target = _a.target, method = _a.method;
        InteractorConfig.forPrototype(target).addCleanupMethod(method, config);
    });
}
export function OnError(config) {
    if (config === void 0) { config = {}; }
    return MakeDecorator(function (_a) {
        var target = _a.target, method = _a.method;
        InteractorConfig.forPrototype(target).addErrorMethod(method, config);
    });
}
export function Before(config) {
    if (config === void 0) { config = {}; }
    return MakeDecorator(function (_a) {
        var target = _a.target, method = _a.method;
        InteractorConfig.forPrototype(target).addSetupMethod(method, config);
    });
}
export function OnSuccess(config) {
    if (config === void 0) { config = {}; }
    return MakeDecorator(function (_a) {
        var target = _a.target, method = _a.method;
        InteractorConfig.forPrototype(target).addAfterMethod(method, config);
    });
}
